import React from 'react';

import stepperStyles from './Stepper.module.css';

const Stepper = ({ activeStep }) => {
    const steps = [
        { key: 'Phone', icon: 'bi-telephone-fill' },
        { key: 'Email', icon: 'bi-envelope-fill' },
        { key: 'BasicDetails', icon: 'bi-person-fill' },
        { key: 'AboutYourSelf', icon: 'bi-person-lines-fill' },
        { key: 'Selfie', icon: 'bi-camera-fill' },
        { key: 'Located', icon: 'bi-geo-alt-fill' },
        { key: 'Religion', icon: 'bi-star-fill' },
        { key: 'Education', icon: 'bi-book-fill' },
        { key: 'JobTitle', icon: 'bi-briefcase-fill' },
        { key: 'Height', icon: 'bi-rulers' },
        { key: 'Personality', icon: 'bi-heart-fill' },
        { key: 'ProfileAnswers', icon: 'bi-ui-checks-grid' },
        { key: 'kidsAndFamily', icon: 'bi-people-fill' },
        { key: 'smoking', icon: 'bi bi-fire' }
    ];

    const activeIndex = steps.findIndex((step) => step.key === activeStep);

    return (
        <div className={`${stepperStyles.progressline}`}>
        {steps.map((step, index) => (
          <React.Fragment key={step.key}>
            {index === activeIndex && (
              <div className={stepperStyles.circle}>
                <i className={`bi ${step.icon}`}></i>
              </div>
            )}
            {index < steps?.length - 1 && <div className={stepperStyles.line}></div>}
          </React.Fragment>
        ))}
      </div>
      
    );
};

export default Stepper;
